import {
  Badge,
  Box,
  Flex,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getMonthlyReportPivotMedicalCondition } from "../../../Http/Index"

interface Props {
  selectedMonth: string
  selectedQuarter?: string
  selectedCompanyId?: string
}

export const MedicalCondition: React.FC<Props> = ({
  selectedMonth,
  selectedQuarter = "",
  selectedCompanyId = "",
}) => {
  const [data, setData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedMonth, selectedQuarter, selectedCompanyId])

  const fetchData = async () => {
    setIsLoading(true)
    try {
      const params: Record<string, any> = {}
      if (selectedQuarter) params.quarter = selectedQuarter
      if (selectedCompanyId) params.companyId = selectedCompanyId
      const res = await getMonthlyReportPivotMedicalCondition(selectedMonth, params)
      const rows = res.data?.data || []
      setData(rows)
    } catch {
    } finally {
      setIsLoading(false)
    }
  }

  const sortedData = [...data].sort((a, b) => {
    const aPending = a._id === "Not Coded / Pending" || a._id === "Unexplained" || a._id === "Being Updated"
    const bPending = b._id === "Not Coded / Pending" || b._id === "Unexplained" || b._id === "Being Updated"
    if (aPending && !bPending) return 1
    if (!aPending && bPending) return -1
    return (b.count || 0) - (a.count || 0)
  })

  const total = sortedData.reduce((sum, r) => sum + (r.count || 0), 0)

  return (
    <Box mt={2}>
      <Flex mb={3} justify="flex-end">
        <Text fontSize="sm" color="gray.500">{sortedData.length} conditions</Text>
      </Flex>

      {isLoading ? (
        <Flex justify="center" py={10}><Spinner /></Flex>
      ) : sortedData.length === 0 ? (
        <Text color="gray.400" textAlign="center" py={6}>No data</Text>
      ) : (
        <Box overflowX="auto" borderWidth={1} borderRadius="md">
          <Table size="sm" variant="simple">
            <Thead bg="gray.100">
              <Tr>
                <Th>#</Th>
                <Th>Medical Condition</Th>
                <Th isNumeric>Count</Th>
                <Th isNumeric>% of Total</Th>
              </Tr>
            </Thead>
            <Tbody>
              {sortedData.map((row, i) => (
                <Tr key={row._id || i} _hover={{ bg: "gray.50" }}>
                  <Td>{i + 1}</Td>
                  <Td>
                    {row._id === "Not Coded / Pending" || row._id === "Unexplained" || row._id === "Being Updated" ? (
                      <Badge colorScheme="gray" variant="subtle">Not Coded / Pending</Badge>
                    ) : (
                      <Text fontWeight="medium">{row._id || "—"}</Text>
                    )}
                  </Td>
                  <Td isNumeric fontWeight="bold">{row.count}</Td>
                  <Td isNumeric color="gray.500">
                    {total > 0 ? ((row.count / total) * 100).toFixed(1) + "%" : "—"}
                  </Td>
                </Tr>
              ))}
              <Tr bg="gray.50" fontWeight="bold">
                <Td></Td>
                <Td>Total</Td>
                <Td isNumeric>{total}</Td>
                <Td isNumeric>100%</Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      )}
    </Box>
  )
}
